import { FormattedMessage } from 'react-intl';
import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { compoundManagementSlice, getOutgoingVehicleSorting } from '../../../reducers/compoundManagementSlice';
import { AppTableCardsSorting } from '../../../sharedComponents/table/AppTableCardsSorting';
import { TableSort } from '../../../sharedComponents/table/SortedTableHeader';
import { Table } from '../../../sharedComponents/table/Table';
import { useSelectedTableColumns } from '../../../sharedComponents/table/useSelectedTableColumns';
import { OutgoingVehicle } from '../../compoundManagement.types';
import { CompoundManagementTableRow } from '../../shared/table/CompoundManagementTableRow';
import { OutgoingSelectionCell } from './OutgoingSelectionCell';
import { OutgoingVehicleBulkSelectionDropdown } from './OutgoingVehicleBulkSelectionDropdown';
import { OutgoingVehiclesTableColumn } from './OutgoingVehiclesTableColumn';
import { OutgoingVehiclesTableDataContent } from './OutgoingVehiclesTableDataContent';

type OutgoingVehiclesTableProps = {
    readonly vehicles: readonly OutgoingVehicle[];
};

export const OutgoingVehiclesTable = ({ vehicles }: OutgoingVehiclesTableProps) => {
    const sorting = useAppSelector(getOutgoingVehicleSorting);
    const dispatch = useAppDispatch();

    const setSorting = (newSorting: TableSort<OutgoingVehiclesTableColumn>) =>
        dispatch(compoundManagementSlice.actions.setOutgoingSorting(newSorting));
    const columnDefinition = useSelectedTableColumns<OutgoingVehiclesTableColumn>();

    return (
        <>
            <AppTableCardsSorting columnDefinition={columnDefinition} sorting={sorting} setSorting={setSorting} />
            <Table
                columnDefinition={columnDefinition}
                sorting={sorting}
                setSorting={setSorting}
                items={vehicles}
                notFoundMessage={
                    <FormattedMessage id="outboundOrderBook.compoundManagement.outgoingVehicles.notFound" />
                }
                selectionHeader={<OutgoingVehicleBulkSelectionDropdown />}
            >
                {vehicles.map((vehicle: OutgoingVehicle) => (
                    <CompoundManagementTableRow
                        key={vehicle.id}
                        highlight={vehicle.departure.isCancelled ? 'danger' : undefined}
                        columnDefinition={columnDefinition}
                        vehicle={vehicle}
                        selectionCell={<OutgoingSelectionCell vehicleId={vehicle.id} />}
                    >
                        {(column) => <OutgoingVehiclesTableDataContent column={column} vehicle={vehicle} />}
                    </CompoundManagementTableRow>
                ))}
            </Table>
        </>
    );
};
